// SAP-Commit-Ergebnis nach Freigabe (nur wenn AB_COMMIT_TARGET=sap): zeigt je-EBELN-Gruppen mit
// Zeilen-Meldungen (gruen/rot) sowohl im Erfolgsfall als auch beim 409-Fehlerfall (Status bleibt
// needs_review — Aufrufer haelt das nach) sowie den 403-Vier-Augen-Block. Eigene Datei, damit
// AbDocumentDetail.js nicht weiter waechst (500-LOC-Regel, "Feature => eigene Datei").
//
// result-Shape: { fourEyes: true, message } (403)
//            | { ok: boolean, groups: [{ ebeln, success, lines: [{ ebelp, ok, message }] }] } (Erfolg/409)

import React from 'react';
import { CheckCircle2, XCircle, AlertOctagon, X } from 'lucide-react';
import { Card, SectionTitle, Chip, iconBtnCls } from './ui';

const AbCommitResult = ({ isDarkMode, t, result, onDismiss }) => {
  if (!result) return null;
  const textMuted = isDarkMode ? 'text-white/55' : 'text-slate-500';
  const closeBtn = (
    <button onClick={onDismiss} className={iconBtnCls(isDarkMode)} title={t('common.close')}>
      <X className="w-4 h-4" />
    </button>
  );

  if (result.fourEyes) {
    return (
      <Card isDarkMode={isDarkMode} className={isDarkMode ? 'border-red-400/30' : 'border-red-200'}>
        <SectionTitle isDarkMode={isDarkMode} right={closeBtn}>
          <span className={`flex items-center gap-2 ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>
            <AlertOctagon className="w-4 h-4" />{t('ab.fourEyesTitle')}
          </span>
        </SectionTitle>
        <p className={`text-sm ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>{result.message}</p>
      </Card>
    );
  }

  const groups = Array.isArray(result.groups) ? result.groups : [];

  return (
    <Card isDarkMode={isDarkMode} className={result.ok
      ? (isDarkMode ? 'border-emerald-400/30' : 'border-emerald-200')
      : (isDarkMode ? 'border-red-400/30' : 'border-red-200')}>
      <SectionTitle isDarkMode={isDarkMode} right={closeBtn}>
        <span className={`flex items-center gap-2 ${result.ok ? (isDarkMode ? 'text-emerald-300' : 'text-emerald-600') : (isDarkMode ? 'text-red-300' : 'text-red-600')}`}>
          {result.ok ? <CheckCircle2 className="w-4 h-4" /> : <XCircle className="w-4 h-4" />}
          {result.ok ? t('ab.commitResultTitleSuccess') : t('ab.commitResultTitleFailed')}
        </span>
      </SectionTitle>
      {!result.ok && (
        <p className={`text-xs mb-3 ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>{t('ab.commitResultFailedHint')}</p>
      )}
      <div className="space-y-3">
        {groups.map((g, gi) => (
          <div key={g.ebeln || gi} className={`rounded-xl p-3 ${isDarkMode ? 'bg-white/[0.04]' : 'bg-slate-50'}`}>
            <div className="flex items-center gap-2 mb-2">
              <span className={`text-sm font-mono font-semibold ${isDarkMode ? 'text-white/85' : 'text-slate-800'}`}>{g.ebeln}</span>
              <Chip tone={g.success ? 'green' : 'red'} isDarkMode={isDarkMode}>
                {g.success ? t('common.yes') : t('common.no')}
              </Chip>
            </div>
            <div className="space-y-1">
              {(Array.isArray(g.lines) ? g.lines : []).map((l, li) => (
                <div key={l.ebelp || li} className="flex items-start gap-2 text-xs">
                  {l.ok
                    ? <CheckCircle2 className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`} />
                    : <XCircle className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-red-400' : 'text-red-600'}`} />}
                  <span className={isDarkMode ? 'text-white/70' : 'text-slate-600'}>
                    {t('ab.commitLineLabel', { ebelp: l.ebelp })}{l.message ? `: ${l.message}` : ''}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
        {groups.length === 0 && (
          <p className={`text-sm ${textMuted}`}>{t('ab.commitResultNoGroups')}</p>
        )}
      </div>
    </Card>
  );
};

export default AbCommitResult;
